import type { ResizingMode } from '@betterpool/api-types/contests-service';
import { Group, useMantineTheme } from '@mantine/core';

import { CurrencyConvertor } from '~/components/utils/formatters';
import PrizeBadge from '~/domains/contest/domains/common/components/PrizeBadge/PrizeBadge';
import { useAdditionalPayoutSettings } from '~/domains/contest/domains/common/hooks/useAdditionalPayoutSettings';
import type { MyUserContest } from '~/domains/contest/domains/myContests/types/userContest';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { Title } from '~/domains/design-system/Title';

function ContestPrizesColumn({
  prize_pool,
  resizing_mode,
  contest,
}: {
  prize_pool: number;
  resizing_mode: ResizingMode;
  contest: Contest | MyUserContest;
}) {
  const theme = useMantineTheme();
  const { isEnabled, type } = useAdditionalPayoutSettings(contest);

  return (
    <Group spacing={theme.other.spacing._4}>
      <Title variant="subhead-small" color={theme.colors.gray[8]}>
        {CurrencyConvertor(prize_pool / 100)}
      </Title>
      <PrizeBadge
        resizingMode={resizing_mode}
        isGuaranteedPlusEnabled={isEnabled}
        additionalPayoutType={type}
      />
    </Group>
  );
}

export default ContestPrizesColumn;
